<template>
  <b-table
    class="table table-responsive table-bordered mt-5"
    hover
    responsive
    :fields="fields"
    :items="items"
  >
    <template #cell(nameTh)="data">
      <div class="d-flex">
        <span>{{ data.item.nameTh }}</span>
      </div>
    </template>
    <template #cell(nameEn)="data">
      <div class="d-flex">
        <span>{{ data.item.nameEn }}</span>
      </div>
    </template>
    <template #cell(parentCode)="data">
      <div class="d-flex">
        <span>{{ data.item.parentCode }}</span>
      </div>
    </template>
    <template #cell(quantity)="data">
      <div class="d-flex justify-content-center">
        <NumberInput v-if="data.item.isEdit"
                     v-model.number="data.item.quantity"
                     :custom-style="{  width: '60%' }" min="1"/>
        <span v-else>{{ data.item.quantity }}</span>
      </div>
    </template>
    <template #cell(action)="data">
      <div v-if="!data.item.isEdit" class="d-flex justify-content-center">
        <button
          class="btn btn-outline-warning"
          style="width: 85px"
          @click="data.item.isEdit = true"
        >
          Edit
        </button>
        <button
          class="btn btn-outline-danger btn-del ml-5"
          @click="deleteItems(data.index)"
        >
          Delete
        </button>
      </div>
      <div v-else class="d-flex justify-content-evenly">
        <button
          class="btn btn-outline-success"
          @click="data.item.isEdit = false"
        >
          Confirm
        </button>
      </div>
    </template>
  </b-table>
</template>

<script>
import fields from "./fieldsSelectedSubBundles.json";
import NumberInput from "components/NumberInput/NumberInput.vue";
export default {
  components: {NumberInput},
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      fields,
    };
  },
  methods: {
    deleteItems(index) {
      this.$emit("deleteSubBundle", index);
    },
  },
};
</script>
